import React, {useState, useEffect, useCallback} from 'react'
import {useParams} from 'react-router-dom'
import {PageTitle} from '../../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import {useAuth} from '../../../../app/modules/auth'
import {FounderMarketBreadCrumb} from '../core/_constants'
import {getFounderMarketDealsDetail} from '../core/_requests'
import FounderMarketDetailData from '../components/FounderMarketDetailData'

const FounderMarketDetail: React.FC = () => {
  const {formatMessage} = useIntl()
  const {dealId} = useParams()
  const [DealDetailData, setDealsDetailData] = useState<any>([])
  const {companyId} = useAuth()
  const [loading, setLoading] = useState(true)
  const {FounderMarketBreadCrumbs} = FounderMarketBreadCrumb()

  const getDealsDetail = useCallback(async () => {
    try {
      setLoading(true)
      const {
        data: {success, data, errors},
      } = await getFounderMarketDealsDetail(dealId!, companyId!)
      if (success) {
        setDealsDetailData(data)
      } else {
        errors?.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }, [dealId, companyId, formatMessage])

  useEffect(() => {
    getDealsDetail()
  }, [getDealsDetail])

  return (
    <>
      <PageTitle
        breadcrumbs={FounderMarketBreadCrumbs}
        description={formatMessage({id: 'Tools & Platform Offers'})}
      >
        {formatMessage({id: 'Founder Market'})}
      </PageTitle>

      <div className='my-6'>
        {DealDetailData && (
          <div className='p-7 bg-white rounded-3' style={{height: 'auto'}}>
            <FounderMarketDetailData dealData={DealDetailData} loading={loading} />
          </div>
        )}
      </div>
    </>
  )
}
export default FounderMarketDetail
